import { Tag } from 'primereact/tag';
import { isRowActive } from '../../utils/active-state';

/** One tag for whether a configuration row is in service — see utils/active-state. */
const ActiveTag = ({ row }: { row: { isActive?: boolean | null } }) => (
  <Tag
    value={isRowActive(row) ? 'Active' : 'Inactive'}
    severity={isRowActive(row) ? 'success' : 'secondary'}
    className="text-xs px-1.5 py-0.5"
  />
);

export default ActiveTag;
